import React, { useState } from "react";
import { File, Textlink } from "@ds/ds-snam/react";
//import {FileStatusType, InputStatusEnum} from "@ds/ds-snam/dist/models/input"; //not found :-(
import {IFileUpload, FileStatusEnum, FileStatusType } from "dataModels/fileInput";
import { useTranslation } from "react-i18next";
import { downloadDocument } from "net/contracts";
import { EntityType,DocumentType } from "shared/constants";
import { saveAs } from 'file-saver';

interface IDsFileInputProps {
    title: string,
    buttonText?:string,
    id: string,
    accept: string,
    maxSize: number,
    onFileUpload: (fileUpload: IFileUpload, id: string) => void,
    defaultStatus:FileStatusType,
    inputLabel?:string,
    documentType?:string,
    action1?:()=>void

}

const DSFileInput: React.FC<IDsFileInputProps> = (props: IDsFileInputProps): JSX.Element => {
    const { title, id, onFileUpload, accept, maxSize, defaultStatus, inputLabel, buttonText} = props;

    const [inputState, setInputState] = useState<FileStatusType>(defaultStatus);
    const [progressValueState, setProgressValueState] = useState<string>('0');
    const [inputDescritionState, setInputDescriptionState] = useState<string>('');

    const {t} = useTranslation(['app']);

    const getFileInputDescrition = (file: File): string => {
        const size = (file.size * 0.000001).toFixed(3);
        return file.name + " (" + size + " Mb)";
    }

    const onFileInputChange = (inputEvent: Event) => {
        const fileList: File[] = (inputEvent as CustomEvent).detail.addedFiles;
        //console.log(fieldName, (inputEvent as CustomEvent).detail);
        if (!fileList.length)
            return;

        const file: File = fileList[0];

        const reader: FileReader = new FileReader();
        //BUG: For some reason state doesn't redraw component, need to access it on dom to change props
        //const elem: DSFile | null = document.querySelector("[input-id='" + id + "']");

        reader.addEventListener('progress', function (e: ProgressEvent<FileReader>) {
            if (e.lengthComputable) {
                let loaded: number = Math.ceil((e.loaded / e.total) * 100);
                setProgressValueState(" " + loaded + "%");   
                //elem!.uploadProgressValue = " " + loaded + "%";
            }
            //elem!.inputStatus = 'uploading';
            setInputState(FileStatusEnum.UPLOADING);
        });

        reader.addEventListener('load', function (e: ProgressEvent<FileReader>) {
            //console.log("Loaded:", e.target?.result);
            //currentState.inputStatus = FileStatusEnum.UPLOADED;
            //currentState.inputDescription = getFileInputDescrition(file);


            setInputState(FileStatusEnum.UPLOADED);
            setInputDescriptionState(getFileInputDescrition(file));
            //elem!.inputStatus = "uploaded";
            //elem!.inputDescription = getFileInputDescrition(file);


            const fileUploadObj: IFileUpload = {
                name: file.name,
                size: file.size,
                content: e.target?.result as string
            };

            onFileUpload(fileUploadObj, id);

        });
        reader.readAsBinaryString(file);

    }

    

    return (
        <>
            <p className="ff-lato-sub_h2-w700 pageTitle">
                {title}
            </p>
            {(props.documentType!==undefined && props.documentType==="personalData") &&
                <div style={{marginBottom:'15px'/*,marginTop:'-10px'*/}}>
                <Textlink
                    textlinkSelected={false}
                    isTopBarVariant={true}
                    textlinkUrl="javascript:void(0)"
                    textlinkText={t(
                        "general.buttons.download_short",
                        { ns: "app" }
                    )}
                    textlinkTextSize="SMALL"
                    isRouterLink={true}
                    textlinkAriaLabel="aria-Textlink"
                    onClickLink={(event:Event) => {
                        props.action1!();
                    }}
                />
                <p style={{display: "inline",fontSize:'95%'}}>{t('dsComponents.fileInput.privacyDocument')}</p>
              </div>
            }
            <File 
                inputLabel={inputLabel?inputLabel:t('dsComponents.fileInput.defaultStatus.title')/*"Trascina il file per caricarlo"*/}
                buttonText={buttonText?buttonText:t('dsComponents.fileInput.defaultStatus.subTitle')/*"Oppure importa file"*/}
                inputId={id}
                inputName={id}
                accept={accept}
                maxSize={maxSize}
                multiple={false}
                inputDescription={inputDescritionState}
                inputStatus={inputState}
                iconRight=""
                //textLinkText="TextLink"
                //textlinkUrl="javascript:void(0)"
                hasIcon=""
                //iconPosition="left"
                //textlinkAriaLabel="Aria label text"
                //isExternalLink={false}
                uploadProgressValue={progressValueState}
                acceptTypeErrorMessage="Tipo del file non è consentito"
                maxSizeErrorMessage="Dimensione del file superiore a quella consentita"
                //isRouterLink={false}
                inputLabelOnLoading="Caricamento file"
                loadingHasAnimation={true}
                fileDescription="(.jpeg, .jpg, .pdf - Max: 10 MB)"
                //onClickLink={onClickLink}
                onFileInputChange={(event: Event) => {
                    onFileInputChange(event);
                }}
            />
        </>


    )
}

export default DSFileInput;